/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import RemoteSelect from 'common/components/RemoteSelect/RemoteSelect';
import TranslatedText from 'common/components/TranslatedText/TranslatedText';

const processOptions = (options) => options.map(({ id, name }) => (
  { value: id, label: <TranslatedText value={name} /> }
));

const CategorySelect = (props) => {
  const { t } = useTranslation();

  return (
    <RemoteSelect
      filters={['id_ne', 'site_null', 'site']}
      url={props.reference ? 'categories/reference' : 'categories'}
      isFilter={props.isFilter}
      placeholder={t('products.category')}
      processOptions={processOptions}
      {...props}
    />
  );
};

export default CategorySelect;
